import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const OFFLINE_TIP_KEY = 'ravepal-offline-tip-seen';

function isStandalone(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

function isIOS(): boolean {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export function OfflineTip() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isStandalone() || !isIOS()) return;
    if (localStorage.getItem(OFFLINE_TIP_KEY)) return;
    setShow(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem(OFFLINE_TIP_KEY, '1');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="bg-primary/10 border-b border-primary/20 px-3 py-2 flex items-center gap-2 text-sm text-text">
      <span className="flex-1">
        {t('offline.tipPrefix')} <strong>{t('offline.tipEmphasis')}</strong>
        {t('offline.tipSuffix')}
      </span>
      <button
        type="button"
        onClick={dismiss}
        className="flex-shrink-0 rounded p-1 text-text-secondary hover:bg-primary/20 hover:text-text transition-colors"
        aria-label={t('common.dismiss')}
      >
        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
